const ENDPOINT = process.env.REACT_APP_ENDPOINT

const submitCompletedPuzzle = async (puzzle_id, blocks) => {
    const mappedBlocks =  blocks.map(block => block.id || block)
    try {
        const response = await fetch(`${ENDPOINT}/snake/complete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                "id": puzzle_id,
                "score_path": mappedBlocks,
                "length": blocks.length
            })
        })
        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.status}`);
        }
        const resp = await response.json();
        return resp
    }
    catch (error) {
        console.error('Error checking match:', error);
    }
}

export default submitCompletedPuzzle;